module.exports = {
  "/": {
    "success": {
      "default": [
        "EMPTY_STATE",
        "FINDER"
      ],
      "welcome": [
        "WELCOME",
        "FINDER"
      ],
      "getting-started": [
        "GETTING_STARTED",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/welcome": {
    "success": {
      "default": [
        "WELCOME",
        "FINDER"
      ],
      "getting-started": [
        "GETTING_STARTED",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/getting-started": {
    "success": {
      "default": [
        "GETTING_STARTED",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/code/:fileId/revisions": {
    "name": "fileRevisions",
    "success": {
      "default": [
        "CODE_EDITOR",
        "FINDER_REVISIONS"
      ]
    },
    "error": [
      "CODE_EDITOR_ERROR",
      "FINDER_REVISIONS_ERROR"
    ]
  },
  "/code/:fileId/dependents": {
    "name": "fileDependents",
    "success": {
      "default": [
        "CODE_EDITOR",
        "FINDER_DEPENDENTS"
      ]
    },
    "error": [
      "FINDER_DEPENDENTS_ERROR",
      "CODE_EDITOR_ERROR"
    ]
  },
  "/code/p/*": {
    "name": "codeByPath",
    "success": {
      "default": [
        "CODE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "CODE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/code/:fileId": {
    "name": "code",
    "success": {
      "default": [
        "CODE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "CODE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/templates/:templateId/revisions": {
    "name": "templateRevisions",
    "success": {
      "default": [
        "DND_TEMPLATE_EDITOR",
        "FINDER_REVISIONS"
      ]
    }
  },
  "/templates/:templateId/dependents": {
    "name": "templateDependents",
    "success": {
      "default": [
        "DND_TEMPLATE_EDITOR",
        "FINDER_DEPENDENTS"
      ]
    },
    "error": [
      "FINDER_DEPENDENTS_ERROR"
    ]
  },
  "/templates/:templateId": {
    "name": "templates",
    "success": {
      "default": [
        "DND_TEMPLATE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/modules/:moduleId/revisions": {
    "name": "moduleRevisions",
    "success": {
      "default": [
        "MODULE_EDITOR",
        "FINDER_REVISIONS"
      ]
    },
    "error": [
      "MODULE_EDITOR_ERROR",
      "FINDER_REVISIONS_ERROR"
    ]
  },
  "/modules/:moduleId/dependents": {
    "name": "moduleDependents",
    "success": {
      "default": [
        "MODULE_EDITOR",
        "FINDER_DEPENDENTS"
      ]
    },
    "error": [
      "MODULE_EDITOR_ERROR",
      "FINDER_DEPENDENTS_ERROR"
    ]
  },
  "/modules/:moduleId/global-content": {
    "name": "moduleGlobalContent",
    "success": {
      "global module editor loaded": [
        "GLOBAL_MODULE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "GLOBAL_MODULE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/modules/p/*": {
    "name": "moduleByPath",
    "success": {
      "default": [
        "MODULE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "MODULE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/modules/:moduleId": {
    "name": "modules",
    "success": {
      "default": [
        "MODULE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "MODULE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/global-modules/:moduleId": {
    "name": "globalModules",
    "success": {
      "default": [
        "GLOBAL_MODULE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "GLOBAL_MODULE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/file/p/*": {
    "name": "fileByPath",
    "success": {
      "default": [
        "FILE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "FILE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/file/:fileId": {
    "name": "file",
    "success": {
      "default": [
        "FILE_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "FILE_EDITOR_ERROR",
      "FINDER_ERROR"
    ]
  },
  "/file/:fileId/revisions": {
    "name": "fileRevisions",
    "success": {
      "default": [
        "FILE_EDITOR",
        "FINDER_REVISIONS"
      ]
    },
    "error": [
      "FILE_EDITOR_ERROR",
      "FINDER_REVISIONS_ERROR"
    ]
  },
  "/folder/:folderId": {
    "name": "folder",
    "success": {
      "default": [
        "FOLDER_EDITOR",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/settings/code": {
    "name": "settingsCode",
    "success": {
      "default": [
        "CODE_SETTINGS",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/settings/javascript-linter": {
    "name": "settingsJavascriptLinter",
    "success": {
      "default": [
        "JAVASCRIPT_LINTER_SETTINGS",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/settings": {
    "name": "settings",
    "success": {
      "default": [
        "GENERAL_SETTINGS",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  },
  "/not-found/:assetType": {
    "name": "notFound",
    "success": {
      "default": [
        "NOT_FOUND",
        "FINDER"
      ]
    },
    "error": [
      "FINDER_ERROR"
    ]
  }
};